export class Config {
  public static BackendAddress = '';
}
